(() => {
  if (window.__btkV2OfferCardsLoaded) return;
  window.__btkV2OfferCardsLoaded = true;

  const ROOT_SELECTOR =
    '[data-btk-v2-offer-cards]';

  function preloadGalleryImages(card) {
    const thumbnails = Array.from(
      card.querySelectorAll(
        '[data-btk-v2-offer-thumb]'
      )
    );

    thumbnails.forEach((thumbnail) => {
      const src = thumbnail.dataset.fullSrc;

      if (!src) return;

      const image = new Image();
      image.src = src;
    });
  }

  function initGallery(card) {
    const gallery = card.querySelector(
      '[data-btk-v2-offer-gallery]'
    );

    const mainImage = card.querySelector(
      '[data-btk-v2-offer-main-image]'
    );

    const mainMedia =
      mainImage?.closest(
        '.btk-v2-offer-cards__main-media'
      ) || null;

    const thumbnails = Array.from(
      card.querySelectorAll(
        '[data-btk-v2-offer-thumb]'
      )
    );

    const thumbnailTrack =
      card.querySelector(
        '[data-btk-v2-thumb-track]'
      );

    const mainPrevButton =
      card.querySelector(
        '[data-btk-v2-gallery-prev]'
      );

    const mainNextButton =
      card.querySelector(
        '[data-btk-v2-gallery-next]'
      );

    if (
      !gallery ||
      !mainImage ||
      !thumbnails.length
    ) {
      return;
    }

    function setArrowIcon(
      button,
      direction
    ) {
      if (!button) return;

      const path =
        direction === 'prev'
          ? 'M12.5 5.5 8 10l4.5 4.5'
          : 'M7.5 5.5 12 10l-4.5 4.5';

      button.innerHTML = `
        <svg
          class="btk-v2-offer-cards__nav-icon"
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="${path}"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      `;
    }

    setArrowIcon(
      mainPrevButton,
      'prev'
    );

    setArrowIcon(
      mainNextButton,
      'next'
    );

    let switchId = 0;

    let activeIndex =
      thumbnails.findIndex(
        (thumbnail) =>
          thumbnail.classList.contains(
            'is-active'
          )
      );

    if (activeIndex < 0) {
      activeIndex = 0;
    }

    function updateMainControls() {
      if (mainPrevButton) {
        mainPrevButton.disabled =
          activeIndex <= 0;
      }

      if (mainNextButton) {
        mainNextButton.disabled =
          activeIndex >=
          thumbnails.length - 1;
      }
    }

    function revealThumbnail(
      thumbnail,
      behavior = 'smooth'
    ) {
      if (
        !thumbnailTrack ||
        !thumbnail
      ) {
        return;
      }

      const targetLeft =
        thumbnail.offsetLeft -
        thumbnailTrack.offsetLeft -
        (
          thumbnailTrack.clientWidth -
          thumbnail.offsetWidth
        ) /
          2;

      thumbnailTrack.scrollTo({
        left: Math.max(0, targetLeft),
        behavior,
      });
    }

    function changeImage(
      index,
      options = {}
    ) {
      const nextIndex = Math.max(
        0,
        Math.min(
          thumbnails.length - 1,
          Number(index) || 0
        )
      );

      const thumbnail =
        thumbnails[nextIndex];

      if (!thumbnail) return;

      const src =
        thumbnail.dataset.fullSrc;

      const alt =
        thumbnail.dataset.alt || '';

      if (!src) return;

      activeIndex = nextIndex;

      thumbnails.forEach(
        (item, itemIndex) => {
          const isActive =
            itemIndex === activeIndex;

          item.classList.toggle(
            'is-active',
            isActive
          );

          if (isActive) {
            item.setAttribute(
              'aria-current',
              'true'
            );
          } else {
            item.removeAttribute(
              'aria-current'
            );
          }
        }
      );

      updateMainControls();

      if (
        options.revealThumbnail !==
        false
      ) {
        revealThumbnail(thumbnail);
      }

      const currentSwitchId =
        ++switchId;

      const image = new Image();

      image.onload = () => {
        if (
          currentSwitchId !==
          switchId
        ) {
          return;
        }

        const media =
          mainImage.closest(
            '.btk-v2-offer-cards__main-media'
          );

        if (!media) {
          mainImage.src = src;
          mainImage.alt = alt;
          return;
        }

        const existingTransitionImage =
          media.querySelector(
            '[data-btk-v2-transition-image]'
          );

        if (existingTransitionImage) {
          existingTransitionImage.remove();
        }

        const outgoingImage =
          mainImage.cloneNode(false);

        outgoingImage.removeAttribute(
          'data-btk-v2-offer-main-image'
        );

        outgoingImage.removeAttribute(
          'loading'
        );

        outgoingImage.className =
          'btk-v2-offer-cards__transition-image';

        outgoingImage.alt = '';

        outgoingImage.setAttribute(
          'aria-hidden',
          'true'
        );

        outgoingImage.setAttribute(
          'data-btk-v2-transition-image',
          ''
        );

        media.appendChild(
          outgoingImage
        );

        mainImage.src = src;
        mainImage.alt = alt;

        requestAnimationFrame(
          () => {
            requestAnimationFrame(
              () => {
                if (
                  currentSwitchId !==
                  switchId
                ) {
                  outgoingImage.remove();
                  return;
                }

                outgoingImage.classList.add(
                  'is-fading'
                );
              }
            );
          }
        );

        const removeOutgoingImage =
          () => {
            if (
              outgoingImage.isConnected
            ) {
              outgoingImage.remove();
            }
          };

        outgoingImage.addEventListener(
          'transitionend',
          removeOutgoingImage,
          {
            once: true,
          }
        );

        window.setTimeout(
          removeOutgoingImage,
          260
        );
      };

      image.src = src;
    }

    thumbnails.forEach(
      (thumbnail, index) => {
        thumbnail.addEventListener(
          'click',
          () => {
            changeImage(index);
          }
        );
      }
    );

    if (mainPrevButton) {
      mainPrevButton.addEventListener(
        'click',
        () => {
          changeImage(
            activeIndex - 1
          );
        }
      );
    }

    if (mainNextButton) {
      mainNextButton.addEventListener(
        'click',
        () => {
          changeImage(
            activeIndex + 1
          );
        }
      );
    }

    if (mainMedia) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStarted = false;

      mainMedia.addEventListener(
        'touchstart',
        (event) => {
          if (
            window.innerWidth > 749 ||
            event.touches.length !== 1
          ) {
            touchStarted = false;
            return;
          }

          const touch =
            event.touches[0];

          touchStartX =
            touch.clientX;

          touchStartY =
            touch.clientY;

          touchStarted = true;
        },
        {
          passive: true,
        }
      );

      mainMedia.addEventListener(
        'touchend',
        (event) => {
          if (
            !touchStarted ||
            window.innerWidth > 749 ||
            !event.changedTouches.length
          ) {
            touchStarted = false;
            return;
          }

          const touch =
            event.changedTouches[0];

          const deltaX =
            touch.clientX -
            touchStartX;

          const deltaY =
            touch.clientY -
            touchStartY;

          touchStarted = false;

          const isHorizontalSwipe =
            Math.abs(deltaX) >= 45 &&
            Math.abs(deltaX) >
              Math.abs(deltaY) * 1.2;

          if (!isHorizontalSwipe) {
            return;
          }

          if (
            deltaX < 0 &&
            activeIndex <
              thumbnails.length - 1
          ) {
            changeImage(
              activeIndex + 1
            );
          } else if (
            deltaX > 0 &&
            activeIndex > 0
          ) {
            changeImage(
              activeIndex - 1
            );
          }
        },
        {
          passive: true,
        }
      );

      mainMedia.addEventListener(
        'touchcancel',
        () => {
          touchStarted = false;
        },
        {
          passive: true,
        }
      );
    }

    thumbnails.forEach(
      (thumbnail, index) => {
        const isActive =
          index === activeIndex;

        thumbnail.classList.toggle(
          'is-active',
          isActive
        );

        if (isActive) {
          thumbnail.setAttribute(
            'aria-current',
            'true'
          );
        } else {
          thumbnail.removeAttribute(
            'aria-current'
          );
        }
      }
    );

    updateMainControls();

    preloadGalleryImages(card);
  }

  function initCountdown(root) {
    const timer = root.querySelector(
      '[data-btk-v2-offers-timer]'
    );

    if (!timer) return;

    const SECOND = 1000;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;

    const daysElement = timer.querySelector(
      '[data-btk-v2-timer-days]'
    );

    const hoursElement = timer.querySelector(
      '[data-btk-v2-timer-hours]'
    );

    const minutesElement = timer.querySelector(
      '[data-btk-v2-timer-minutes]'
    );

    const secondsElement = timer.querySelector(
      '[data-btk-v2-timer-seconds]'
    );

    if (
      !daysElement ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      return;
    }

    function getNumberAttribute(attribute) {
      const value = Number(
        root.getAttribute(attribute)
      );

      return Number.isFinite(value)
        ? Math.max(0, value)
        : 0;
    }

    const startingDays =
      getNumberAttribute(
        'data-btk-v2-countdown-days'
      );

    const startingHours =
      getNumberAttribute(
        'data-btk-v2-countdown-hours'
      );

    const startingMinutes =
      getNumberAttribute(
        'data-btk-v2-countdown-minutes'
      );

    const startingSeconds =
      getNumberAttribute(
        'data-btk-v2-countdown-seconds'
      );

    const duration =
      startingDays * DAY +
      startingHours * HOUR +
      startingMinutes * MINUTE +
      startingSeconds * SECOND;

    const countdownId =
      root.getAttribute(
        'data-btk-v2-countdown-id'
      ) ||
      root.id ||
      'default';

    const durationSignature = [
      startingDays,
      startingHours,
      startingMinutes,
      startingSeconds,
    ].join('-');

    const storageKey =
      `btk-v2-offer-countdown-${countdownId}-${durationSignature}`;

    let endTime = null;

    function pad(value) {
      return String(
        Math.max(0, value)
      ).padStart(2, '0');
    }

    function setValues(
      days,
      hours,
      minutes,
      seconds
    ) {
      daysElement.textContent =
        pad(days);

      hoursElement.textContent =
        pad(hours);

      minutesElement.textContent =
        pad(minutes);

      secondsElement.textContent =
        pad(seconds);
    }

    function stopCountdown() {
      if (!root.__btkV2OfferTimer) {
        return;
      }

      window.clearInterval(
        root.__btkV2OfferTimer
      );

      root.__btkV2OfferTimer = null;
    }

    root.__btkV2OfferStopTimer =
      stopCountdown;

    stopCountdown();

    if (duration <= 0) {
      setValues(0, 0, 0, 0);

      console.warn(
        'BTK V2 Offer Cards: countdown duration must be greater than zero.'
      );

      return;
    }

    /*
      Restore this visitor's existing countdown
      instead of restarting on every refresh.
    */
    try {
      const storedEndTime = Number(
        window.localStorage.getItem(
          storageKey
        )
      );

      if (
        Number.isFinite(storedEndTime) &&
        storedEndTime > 0
      ) {
        endTime = storedEndTime;
      }
    } catch (error) {
      /*
        localStorage may be unavailable.
      */
    }

    /*
      First visit for this countdown duration.
    */
    if (!endTime) {
      endTime =
        Date.now() + duration;

      try {
        window.localStorage.setItem(
          storageKey,
          String(endTime)
        );
      } catch (error) {
        /*
          Ignore storage errors.
        */
      }
    }

    function renewCountdown() {
      endTime =
        Date.now() + duration;

      try {
        window.localStorage.setItem(
          storageKey,
          String(endTime)
        );
      } catch (error) {
        /*
          Ignore storage errors.
        */
      }

      setValues(
        startingDays,
        startingHours,
        startingMinutes,
        startingSeconds
      );
    }

    function updateCountdown() {
      let difference =
        endTime - Date.now();

      /*
        Automatically start a fresh countdown
        whenever the current countdown expires.
      */
      if (difference <= 0) {
        renewCountdown();

        difference =
          endTime - Date.now();
      }

      const totalSeconds = Math.max(
        0,
        Math.floor(
          difference / SECOND
        )
      );

      const days = Math.floor(
        totalSeconds / 86400
      );

      const hours = Math.floor(
        (totalSeconds % 86400) /
          3600
      );

      const minutes = Math.floor(
        (totalSeconds % 3600) /
          60
      );

      const seconds =
        totalSeconds % 60;

      setValues(
        days,
        hours,
        minutes,
        seconds
      );
    }

    updateCountdown();

    root.__btkV2OfferTimer =
      window.setInterval(
        updateCountdown,
        1000
      );
  }

  function initSection(root) {
    if (
      !root ||
      root.dataset.btkV2OfferCardsInitialized ===
        'true'
    ) {
      return;
    }

    root.dataset.btkV2OfferCardsInitialized =
      'true';

    root
      .querySelectorAll(
        '[data-btk-v2-offer-card]'
      )
      .forEach((card) => {
        initGallery(card);
      });

    initCountdown(root);
  }

  function initAllSections(scope = document) {
    if (
      scope.matches?.(ROOT_SELECTOR)
    ) {
      initSection(scope);
      return;
    }

    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllSections();
      }
    );
  } else {
    initAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllSections(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const root =
        event.target.matches?.(ROOT_SELECTOR)
          ? event.target
          : event.target.querySelector(
              ROOT_SELECTOR
            );

      if (
        root &&
        typeof root.__btkV2OfferStopTimer ===
          'function'
      ) {
        root.__btkV2OfferStopTimer();
      }
    }
  );
})();

/* ============================================================
   BTK V2 OFFER CARDS — FLAVOR + CHECKOUT EXTENSION
   ============================================================ */
(() => {
  if (window.__btkV2OfferCardsCheckoutLoaded) return;
  window.__btkV2OfferCardsCheckoutLoaded = true;

  const ROOT_SELECTOR = '[data-btk-v2-offer-cards]';
  const CARD_SELECTOR = '[data-btk-v2-offer-card]';
  const FLAVOR_SELECTOR = '[data-btk-v2-flavor-select]';
  const BOGO_RELOAD_MARKER = '_btk_v2_offer_reload';
  const productRequests = new Map();

  const shopRoot = () =>
    window.Shopify?.routes?.root || '/';

  const shopRoute = (path) =>
    `${shopRoot()}${String(path || '').replace(/^\/+/, '')}`;

  const clampInt = (value, min = 1) =>
    Math.max(
      min,
      Math.floor(Number(value) || 0)
    );

  function normalizeParamString(rawValue) {
    if (!rawValue) return '';

    let normalized = String(rawValue).trim();

    if (!normalized) return '';

    if (normalized.includes('://')) {
      try {
        normalized = new URL(normalized)
          .search
          .replace(/^\?/, '');
      } catch (error) {}
    }

    const queryStartIndex =
      normalized.indexOf('?');

    if (queryStartIndex > -1) {
      normalized = normalized.slice(
        queryStartIndex + 1
      );
    }

    normalized =
      normalized.replace(/^[?&]+/, '');

    const hashIndex =
      normalized.indexOf('#');

    if (hashIndex > -1) {
      normalized =
        normalized.slice(0, hashIndex);
    }

    return normalized.trim();
  }

  function parseDiscountCodes(raw) {
    return String(raw || '')
      .split(/[\n,]+/g)
      .map((value) => value.trim())
      .filter(Boolean);
  }

  function parseConfig(root) {
    if (!root) {
      return {
        flavorProductHandle: '',
        flavorSelectorLabel: 'Select Protein Flavor:',
        clearCart: true,
        flavors: [],
        offers: {},
      };
    }

    if (root.__btkV2CheckoutConfig) {
      return root.__btkV2CheckoutConfig;
    }

    const script = root.querySelector(
      '[data-btk-v2-offer-config]'
    );

    let parsed = {};

    try {
      parsed = script
        ? JSON.parse(
            script.textContent || '{}'
          )
        : {};
    } catch (error) {
      console.warn(
        'BTK V2 Offer Cards: unable to parse checkout configuration.',
        error
      );
    }

    root.__btkV2CheckoutConfig = {
      flavorProductHandle: String(
        parsed.flavorProductHandle || ''
      ).trim(),

      flavorSelectorLabel: String(
        parsed.flavorSelectorLabel ||
          'Select Protein Flavor:'
      ).trim(),

      clearCart:
        parsed.clearCart !== false,

      flavors: Array.isArray(
        parsed.flavors
      )
        ? parsed.flavors
        : [],

      offers:
        parsed.offers &&
        typeof parsed.offers === 'object'
          ? parsed.offers
          : {},
    };

    return root.__btkV2CheckoutConfig;
  }

  function getOfferKey(card) {
    if (
      card?.classList.contains(
        'btk-v2-offer-cards__card--offer-1'
      )
    ) {
      return 'offer_1';
    }

    if (
      card?.classList.contains(
        'btk-v2-offer-cards__card--offer-2'
      )
    ) {
      return 'offer_2';
    }

    return '';
  }

  function getOfferConfig(root, card) {
    const config = parseConfig(root);
    const key = getOfferKey(card);

    return {
      key,
      ...(config.offers[key] || {}),
    };
  }

  function getButton(card) {
    return (
      card?.querySelector(
        '.btk-v2-offer-cards__button'
      ) || null
    );
  }

  function setStatus(
    card,
    message,
    isError = true
  ) {
    const status = card?.querySelector(
      '[data-btk-v2-offer-status]'
    );

    if (!status) return;

    status.textContent =
      message || '';

    status.dataset.statusType =
      isError ? 'error' : 'success';
  }

  function getCustomFlavorOptions(card) {
    return Array.from(
      card?.querySelectorAll(
        '[data-btk-v2-flavor-option]'
      ) || []
    );
  }

  function getFlavorImageSrc(
    variant,
    product
  ) {
    const variantImage =
      variant?.featured_image;

    if (
      variantImage &&
      typeof variantImage === 'object' &&
      variantImage.src
    ) {
      return String(
        variantImage.src
      );
    }

    if (
      typeof variantImage === 'string'
    ) {
      return variantImage;
    }

    if (
      typeof product?.featured_image ===
        'string'
    ) {
      return product.featured_image;
    }

    return '';
  }

  function closeFlavorMenu(card) {
    const wrapper =
      card?.querySelector(
        '[data-btk-v2-flavor-wrapper]'
      );

    const trigger =
      card?.querySelector(
        '[data-btk-v2-flavor-trigger]'
      );

    const menu =
      card?.querySelector(
        '[data-btk-v2-flavor-menu]'
      );

    if (!wrapper || !trigger || !menu) {
      return;
    }

    wrapper.classList.remove(
      'is-open'
    );

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

    menu.hidden = true;
  }

  function syncFlavorDisplay(card) {
    const select =
      card?.querySelector(
        FLAVOR_SELECTOR
      );

    const selectedLabel =
      card?.querySelector(
        '[data-btk-v2-flavor-selected-label]'
      );

    const selectedThumb =
      card?.querySelector(
        '[data-btk-v2-flavor-selected-thumb]'
      );

    const selectedImage =
      card?.querySelector(
        '[data-btk-v2-flavor-selected-image]'
      );

    if (
      !select ||
      !selectedLabel ||
      !selectedThumb ||
      !selectedImage
    ) {
      return;
    }

    const selectedOption =
      select.selectedIndex >= 0
        ? select.options[
            select.selectedIndex
          ]
        : null;

    const selectedValue =
      selectedOption?.value || '';

    const customOptions =
      getCustomFlavorOptions(card);

    customOptions.forEach(
      (optionButton) => {
        optionButton.setAttribute(
          'aria-selected',
          optionButton.dataset.value ===
            selectedValue
            ? 'true'
            : 'false'
        );
      }
    );

    if (!selectedValue) {
      selectedLabel.textContent =
        select.disabled
          ? 'All flavors sold out'
          : 'Choose a flavor';

      selectedImage.removeAttribute(
        'src'
      );

      selectedThumb.hidden = true;
      return;
    }

    selectedLabel.textContent =
      selectedOption?.dataset
        .baseLabel ||
      selectedOption?.textContent ||
      'Choose a flavor';

    const imageSrc =
      selectedOption?.dataset
        .imageSrc || '';

    if (imageSrc) {
      selectedImage.src = imageSrc;
      selectedImage.alt = '';
      selectedThumb.hidden = false;
    } else {
      selectedImage.removeAttribute(
        'src'
      );
      selectedThumb.hidden = true;
    }
  }

  function setButtonState(
    card,
    isBusy = false
  ) {
    const button = getButton(card);

    const select = card?.querySelector(
      FLAVOR_SELECTOR
    );

    const trigger =
      card?.querySelector(
        '[data-btk-v2-flavor-trigger]'
      );

    if (!button) return;

    const option =
      select &&
      select.selectedIndex >= 0
        ? select.options[
            select.selectedIndex
          ]
        : null;

    const hasValidFlavor =
      !!select &&
      !select.disabled &&
      !!select.value &&
      !!option &&
      !option.disabled;

    const disabled =
      isBusy || !hasValidFlavor;

    button.setAttribute(
      'aria-disabled',
      disabled ? 'true' : 'false'
    );

    button.setAttribute(
      'aria-busy',
      isBusy ? 'true' : 'false'
    );

    button.classList.toggle(
      'is-busy',
      isBusy
    );

    if (trigger) {
      trigger.disabled =
        isBusy || !!select?.disabled;
    }

    if (isBusy) {
      closeFlavorMenu(card);
    }
  }

  function createFlavorSelector(
    root,
    card
  ) {
    const existing =
      card.querySelector(
        FLAVOR_SELECTOR
      );

    if (existing) return existing;

    const mount =
      card.querySelector(
        '[data-btk-v2-flavor-mount]'
      );

    if (!mount) return null;

    const config = parseConfig(root);
    const offerKey = getOfferKey(card);

    const rootId = String(
      root.id || 'btk-v2-offers'
    ).replace(
      /[^a-zA-Z0-9_-]/g,
      '-'
    );

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'btk-v2-offer-cards__flavor-wrap';

    wrapper.setAttribute(
      'data-btk-v2-flavor-wrapper',
      ''
    );

    const label =
      document.createElement('div');

    label.className =
      'btk-v2-offer-cards__flavor-label';

    label.id =
      `${rootId}-${offerKey}-flavor-label`;

    label.textContent =
      config.flavorSelectorLabel ||
      'Select Protein Flavor:';

    const select =
      document.createElement('select');

    select.className =
      'btk-v2-offer-cards__flavor-select';

    select.setAttribute(
      'data-btk-v2-flavor-select',
      ''
    );

    select.id =
      `${rootId}-${offerKey}-flavor`;

    select.tabIndex = -1;

    select.setAttribute(
      'aria-hidden',
      'true'
    );

    const trigger =
      document.createElement('button');

    trigger.type = 'button';

    trigger.className =
      'btk-v2-offer-cards__flavor-trigger';

    trigger.setAttribute(
      'data-btk-v2-flavor-trigger',
      ''
    );

    trigger.setAttribute(
      'aria-haspopup',
      'listbox'
    );

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

    trigger.setAttribute(
      'aria-labelledby',
      label.id
    );

    const selectedThumb =
      document.createElement('span');

    selectedThumb.className =
      'btk-v2-offer-cards__flavor-selected-thumb';

    selectedThumb.setAttribute(
      'data-btk-v2-flavor-selected-thumb',
      ''
    );

    selectedThumb.hidden = true;

    const selectedImage =
      document.createElement('img');

    selectedImage.className =
      'btk-v2-offer-cards__flavor-selected-image';

    selectedImage.setAttribute(
      'data-btk-v2-flavor-selected-image',
      ''
    );

    selectedImage.alt = '';

    selectedThumb.appendChild(
      selectedImage
    );

    const selectedLabel =
      document.createElement('span');

    selectedLabel.className =
      'btk-v2-offer-cards__flavor-selected-label';

    selectedLabel.setAttribute(
      'data-btk-v2-flavor-selected-label',
      ''
    );

    selectedLabel.textContent =
      'Choose a flavor';

    const chevron =
      document.createElement('span');

    chevron.className =
      'btk-v2-offer-cards__flavor-chevron';

    chevron.setAttribute(
      'aria-hidden',
      'true'
    );

    trigger.appendChild(
      selectedThumb
    );

    trigger.appendChild(
      selectedLabel
    );

    trigger.appendChild(chevron);

    const menu =
      document.createElement('div');

    menu.className =
      'btk-v2-offer-cards__flavor-menu';

    menu.id =
      `${rootId}-${offerKey}-flavor-menu`;

    menu.setAttribute(
      'data-btk-v2-flavor-menu',
      ''
    );

    menu.setAttribute(
      'role',
      'listbox'
    );

    menu.setAttribute(
      'aria-label',
      'Protein flavor options'
    );

    menu.hidden = true;

    trigger.setAttribute(
      'aria-controls',
      menu.id
    );

    config.flavors.forEach(
      (flavor, index) => {
        const variantId = String(
          flavor?.variantId || ''
        ).trim();

        const flavorLabel = String(
          flavor?.label || ''
        ).trim();

        if (
          !variantId ||
          !flavorLabel
        ) {
          return;
        }

        const option =
          document.createElement(
            'option'
          );

        option.value = variantId;
        option.textContent =
          flavorLabel;

        option.dataset.baseLabel =
          flavorLabel;

        if (
          select.options.length === 0
        ) {
          option.selected = true;
        }

        select.appendChild(option);

        const optionButton =
          document.createElement(
            'button'
          );

        optionButton.type = 'button';

        optionButton.className =
          'btk-v2-offer-cards__flavor-option';

        optionButton.setAttribute(
          'data-btk-v2-flavor-option',
          ''
        );

        optionButton.setAttribute(
          'role',
          'option'
        );

        optionButton.setAttribute(
          'aria-selected',
          index === 0
            ? 'true'
            : 'false'
        );

        optionButton.dataset.value =
          variantId;

        const thumb =
          document.createElement('span');

        thumb.className =
          'btk-v2-offer-cards__flavor-option-thumb';

        const image =
          document.createElement('img');

        image.className =
          'btk-v2-offer-cards__flavor-option-image';

        image.setAttribute(
          'data-btk-v2-flavor-option-image',
          ''
        );

        image.alt = '';
        image.hidden = true;

        thumb.appendChild(image);

        const text =
          document.createElement('span');

        text.textContent =
          flavorLabel;

        optionButton.appendChild(
          thumb
        );

        optionButton.appendChild(text);

        optionButton.addEventListener(
          'click',
          () => {
            if (optionButton.disabled) {
              return;
            }

            select.value =
              variantId;

            select.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true,
                }
              )
            );

            closeFlavorMenu(card);
            trigger.focus();
          }
        );

        menu.appendChild(
          optionButton
        );
      }
    );

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    wrapper.appendChild(trigger);
    wrapper.appendChild(menu);

    mount.replaceChildren(
      wrapper
    );

    trigger.addEventListener(
      'click',
      () => {
        if (trigger.disabled) return;

        const willOpen =
          menu.hidden;

        if (willOpen) {
          wrapper.classList.add(
            'is-open'
          );

          trigger.setAttribute(
            'aria-expanded',
            'true'
          );

          menu.hidden = false;
        } else {
          closeFlavorMenu(card);
        }
      }
    );

    select.addEventListener(
      'change',
      () => {
        syncFlavorDisplay(card);
        setStatus(card, '');
        setButtonState(
          card,
          false
        );
      }
    );

    wrapper.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Escape') {
          return;
        }

        closeFlavorMenu(card);
        trigger.focus();
      }
    );

    document.addEventListener(
      'click',
      (event) => {
        if (
          !wrapper.contains(
            event.target
          )
        ) {
          closeFlavorMenu(card);
        }
      }
    );

    syncFlavorDisplay(card);

    return select;
  }

  function createStatus(card) {
    if (
      card.querySelector(
        '[data-btk-v2-offer-status]'
      )
    ) {
      return;
    }

    const button =
      getButton(card);

    if (!button) return;

    const status =
      document.createElement('div');

    status.className =
      'btk-v2-offer-cards__status';

    status.setAttribute(
      'data-btk-v2-offer-status',
      ''
    );

    status.setAttribute(
      'role',
      'status'
    );

    status.setAttribute(
      'aria-live',
      'polite'
    );

    button.after(status);
  }

  function fetchProduct(handle) {
    const normalizedHandle =
      String(handle || '').trim();

    if (!normalizedHandle) {
      return Promise.resolve(null);
    }

    if (
      productRequests.has(
        normalizedHandle
      )
    ) {
      return productRequests.get(
        normalizedHandle
      );
    }

    const request = fetch(
      `${shopRoot()}products/${encodeURIComponent(
        normalizedHandle
      )}.js`,
      {
        method: 'GET',
        headers: {
          Accept:
            'application/json',
        },
        credentials:
          'same-origin',
        cache: 'no-store',
      }
    ).then(
      async (response) => {
        if (!response.ok) {
          throw new Error(
            `Unable to check flavor availability (${response.status}).`
          );
        }

        return response.json();
      }
    );

    productRequests.set(
      normalizedHandle,
      request
    );

    return request;
  }

  async function syncFlavorAvailability(
    root,
    card
  ) {
    const select =
      card.querySelector(
        FLAVOR_SELECTOR
      );

    if (!select) return;

    const handle =
      parseConfig(
        root
      ).flavorProductHandle;

    if (!handle) {
      select.disabled = false;

      syncFlavorDisplay(card);

      setButtonState(
        card,
        false
      );

      console.warn(
        'BTK V2 Offer Cards: select a Source product for stock detection in the Theme Editor.'
      );

      return;
    }

    select.disabled = true;

    setButtonState(
      card,
      false
    );

    try {
      const product =
        await fetchProduct(handle);

      const variants =
        Array.isArray(
          product?.variants
        )
          ? product.variants
          : [];

      const variantMap =
        new Map(
          variants.map(
            (variant) => [
              String(variant.id),
              variant,
            ]
          )
        );

      const configuredImageMap =
        new Map(
          parseConfig(root).flavors.map(
            (flavor) => [
              String(
                flavor?.variantId || ''
              ).trim(),
              String(
                flavor?.imageSrc || ''
              ).trim(),
            ]
          )
        );

      const customOptions =
        getCustomFlavorOptions(card);

      let availableCount = 0;
      let firstAvailableValue = '';

      Array.from(
        select.options
      ).forEach(
        (option) => {
          if (!option.value) return;

          const variant =
            variantMap.get(
              String(option.value)
            );

          const isAvailable =
            !!variant &&
            !!variant.available;

          const configuredImageSrc =
            configuredImageMap.get(
              String(option.value)
            ) || '';

          const imageSrc =
            configuredImageSrc ||
            getFlavorImageSrc(
              variant,
              product
            );

          option.disabled =
            !isAvailable;

          option.dataset.imageSrc =
            imageSrc;

          const optionButton =
            customOptions.find(
              (button) =>
                button.dataset.value ===
                option.value
            );

          if (optionButton) {
            optionButton.disabled =
              !isAvailable;

            optionButton.classList.toggle(
              'is-sold-out',
              !isAvailable
            );

            optionButton.setAttribute(
              'aria-disabled',
              isAvailable
                ? 'false'
                : 'true'
            );

            optionButton.dataset.imageSrc =
              imageSrc;

            const optionImage =
              optionButton.querySelector(
                '[data-btk-v2-flavor-option-image]'
              );

            if (optionImage) {
              if (imageSrc) {
                optionImage.src =
                  imageSrc;

                optionImage.hidden =
                  false;
              } else {
                optionImage.removeAttribute(
                  'src'
                );

                optionImage.hidden =
                  true;
              }
            }
          }

          if (isAvailable) {
            availableCount += 1;

            if (!firstAvailableValue) {
              firstAvailableValue =
                option.value;
            }
          }
        }
      );

      const selectedOption =
        select.selectedIndex >= 0
          ? select.options[
              select.selectedIndex
            ]
          : null;

      if (
        !selectedOption?.value ||
        selectedOption.disabled
      ) {
        select.value =
          firstAvailableValue;
      }

      select.disabled =
        availableCount === 0;

      syncFlavorDisplay(card);

      if (
        availableCount === 0
      ) {
        setStatus(
          card,
          'All protein flavors are currently sold out.'
        );
      } else {
        setStatus(card, '');
      }
    } catch (error) {
      select.disabled = false;

      syncFlavorDisplay(card);

      setStatus(
        card,
        'Unable to verify flavor availability. Please refresh and try again.'
      );

      console.warn(
        'BTK V2 Offer Cards: flavor availability check failed.',
        error
      );
    }

    setButtonState(
      card,
      false
    );
  }

  function getAllConfiguredBogoKeys(
    root
  ) {
    const keys = new Set();

    const config =
      parseConfig(root);

    Object.values(
      config.offers
    ).forEach(
      (offer) => {
        const params =
          new URLSearchParams(
            normalizeParamString(
              offer?.bogoParams ||
                ''
            )
          );

        params.forEach(
          (value, key) => {
            if (
              key &&
              key !==
                BOGO_RELOAD_MARKER
            ) {
              keys.add(key);
            }
          }
        );
      }
    );

    return keys;
  }

  function getBogoParams(
    root,
    card
  ) {
    return normalizeParamString(
      getOfferConfig(
        root,
        card
      ).bogoParams || ''
    );
  }

  function reloadForBogoCheckout(
    root,
    card
  ) {
    const configuredKeys =
      getAllConfiguredBogoKeys(
        root
      );

    if (!configuredKeys.size) {
      return false;
    }

    const effective =
      new URLSearchParams(
        getBogoParams(
          root,
          card
        )
      );

    const current =
      new URLSearchParams(
        window.location.search
      );

    let needsReload = false;

    configuredKeys.forEach(
      (key) => {
        const effectiveValue =
          effective.get(key);

        const currentValue =
          current.get(key);

        if (
          effectiveValue === null
        ) {
          if (
            current.has(key)
          ) {
            needsReload = true;
          }
        } else if (
          currentValue !==
          effectiveValue
        ) {
          needsReload = true;
        }
      }
    );

    if (!needsReload) {
      return false;
    }

    const select =
      card.querySelector(
        FLAVOR_SELECTOR
      );

    const offer =
      getOfferConfig(
        root,
        card
      );

    const url =
      new URL(
        window.location.href
      );

    configuredKeys.forEach(
      (key) =>
        url.searchParams.delete(
          key
        )
    );

    effective.forEach(
      (value, key) => {
        if (
          key &&
          key !==
            BOGO_RELOAD_MARKER
        ) {
          url.searchParams.set(
            key,
            value
          );
        }
      }
    );

    url.searchParams.set(
      BOGO_RELOAD_MARKER,
      JSON.stringify({
        mode: 'checkout',
        rootId: root.id || '',
        offerKey: offer.key,
        variantId:
          select?.value || '',

        scrollX: Math.round(
          window.scrollX ||
            window.pageXOffset ||
            0
        ),

        scrollY: Math.round(
          window.scrollY ||
            window.pageYOffset ||
            0
        ),
      })
    );

    if (
      'scrollRestoration' in
      window.history
    ) {
      window.history
        .scrollRestoration =
        'manual';
    }

    window.location.replace(
      url.toString()
    );

    return true;
  }

  function getReloadState() {
    const raw =
      new URL(
        window.location.href
      ).searchParams.get(
        BOGO_RELOAD_MARKER
      );

    if (!raw) return null;

    try {
      const parsed =
        JSON.parse(raw);

      return (
        parsed &&
        typeof parsed ===
          'object'
      )
        ? parsed
        : null;
    } catch (error) {
      return null;
    }
  }

  function stripReloadMarker() {
    const url =
      new URL(
        window.location.href
      );

    if (
      !url.searchParams.has(
        BOGO_RELOAD_MARKER
      )
    ) {
      return;
    }

    url.searchParams.delete(
      BOGO_RELOAD_MARKER
    );

    window.history.replaceState(
      {},
      '',
      url.pathname +
        (url.search || '') +
        url.hash
    );
  }

  function restoreScroll(state) {
    const scrollX =
      Number(state?.scrollX);

    const scrollY =
      Number(state?.scrollY);

    if (
      !Number.isFinite(
        scrollX
      ) ||
      !Number.isFinite(
        scrollY
      )
    ) {
      return;
    }

    const html =
      document.documentElement;

    const previous =
      html.style.scrollBehavior;

    html.style.scrollBehavior =
      'auto';

    const restore = () =>
      window.scrollTo(
        Math.max(0, scrollX),
        Math.max(0, scrollY)
      );

    restore();

    requestAnimationFrame(
      () =>
        requestAnimationFrame(
          restore
        )
    );

    window.setTimeout(
      () => {
        restore();

        html.style
          .scrollBehavior =
          previous;
      },
      120
    );
  }

  async function postJSON(
    url,
    body
  ) {
    const response =
      await fetch(url, {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
          Accept:
            'application/json',
        },

        body: JSON.stringify(
          body || {}
        ),

        credentials:
          'same-origin',

        cache: 'no-store',
      });

    const contentType =
      response.headers.get(
        'content-type'
      ) || '';

    const data =
      contentType.includes(
        'application/json'
      )
        ? await response.json()
        : await response.text();

    if (!response.ok) {
      const message =
        (
          data &&
          (
            data.description ||
            data.message
          )
        ) ||
        (
          typeof data ===
            'string'
            ? data
            : 'Request failed'
        );

      throw new Error(
        message
      );
    }

    return data;
  }

  async function fetchCart() {
    const response =
      await fetch(
        shopRoute(
          'cart.js'
        ),
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest',
          },

          credentials:
            'same-origin',

          cache: 'no-store',
        }
      );

    if (!response.ok) {
      throw new Error(
        `Unable to read cart (${response.status}).`
      );
    }

    return response.json();
  }

  function wait(ms) {
    return new Promise(
      (resolve) =>
        window.setTimeout(
          resolve,
          ms
        )
    );
  }

  function waitForBogoGift(
    knownItemCount
  ) {
    return new Promise(
      (resolve) => {
        const interval = 200;
        const maxWait = 6000;
        let elapsed = 0;

        const check =
          async () => {
            try {
              const cart =
                await fetchCart();

              if (
                typeof cart
                  ?.item_count ===
                  'number' &&
                cart.item_count >
                  knownItemCount
              ) {
                resolve(true);
                return;
              }
            } catch (error) {
              resolve(false);
              return;
            }

            elapsed += interval;

            if (
              elapsed >=
              maxWait
            ) {
              resolve(false);
              return;
            }

            window.setTimeout(
              check,
              interval
            );
          };

        window.setTimeout(
          check,
          interval
        );
      }
    );
  }

  function getBogoAttributes(
    root,
    card
  ) {
    const params =
      new URLSearchParams(
        getBogoParams(
          root,
          card
        )
      );

    const attributes = {};
    let hasAny = false;

    params.forEach(
      (value, key) => {
        if (
          !key ||
          key ===
            BOGO_RELOAD_MARKER
        ) {
          return;
        }

        attributes[key] =
          value;

        hasAny = true;
      }
    );

    return hasAny
      ? attributes
      : null;
  }

  function getCheckoutUrl(
    root,
    card
  ) {
    const checkoutUrl =
      new URL(
        '/checkout',
        window.location.origin
      );

    new URLSearchParams(
      window.location.search
    ).forEach(
      (value, key) => {
        if (
          key &&
          key !==
            BOGO_RELOAD_MARKER
        ) {
          checkoutUrl
            .searchParams
            .set(
              key,
              value
            );
        }
      }
    );

    new URLSearchParams(
      getBogoParams(
        root,
        card
      )
    ).forEach(
      (value, key) => {
        if (
          key &&
          key !==
            BOGO_RELOAD_MARKER
        ) {
          checkoutUrl
            .searchParams
            .set(
              key,
              value
            );
        }
      }
    );

    const discountCodes =
      parseDiscountCodes(
        getOfferConfig(
          root,
          card
        ).discountCodes || ''
      );

    if (
      discountCodes.length
    ) {
      checkoutUrl
        .searchParams
        .set(
          'discount',
          discountCodes.join(',')
        );
    }

    return (
      checkoutUrl.pathname +
      checkoutUrl.search +
      checkoutUrl.hash
    );
  }

  async function handleCheckout(
    button,
    options = {}
  ) {
    const card =
      button?.closest(
        CARD_SELECTOR
      );

    const root =
      button?.closest(
        ROOT_SELECTOR
      );

    if (
      !card ||
      !root ||
      card.__btkV2OfferSubmitting
    ) {
      return;
    }

    const select =
      card.querySelector(
        FLAVOR_SELECTOR
      );

    const selectedOption =
      select &&
      select.selectedIndex >= 0
        ? select.options[
            select.selectedIndex
          ]
        : null;

    if (
      !select?.value ||
      !selectedOption ||
      selectedOption.disabled
    ) {
      setStatus(
        card,
        'Please choose an available protein flavor.'
      );

      setButtonState(
        card,
        false
      );

      return;
    }

    if (
      !options.skipBogoReload &&
      reloadForBogoCheckout(
        root,
        card
      )
    ) {
      return;
    }

    const config =
      parseConfig(root);

    const offer =
      getOfferConfig(
        root,
        card
      );

    const variantId =
      Number(select.value);

    const sellingPlanId =
      Number(
        offer.sellingPlanId ||
          0
      );

    const quantity =
      clampInt(
        offer.selectedVariantQuantityMultiplier,
        1
      );

    if (
      !Number.isFinite(
        variantId
      ) ||
      variantId <= 0
    ) {
      setStatus(
        card,
        'The selected variant does not have a valid variant ID.'
      );

      return;
    }

    const item = {
      id: variantId,
      quantity,
    };

    if (
      Number.isFinite(
        sellingPlanId
      ) &&
      sellingPlanId > 0
    ) {
      item.selling_plan =
        sellingPlanId;
    }

    card.__btkV2OfferSubmitting =
      true;

    setStatus(card, '');

    setButtonState(
      card,
      true
    );

    try {
      if (
        config.clearCart
      ) {
        await postJSON(
          shopRoute(
            'cart/clear.js'
          ),
          {}
        );

        await wait(180);
      }

      let cartBeforeAdd = null;

      try {
        cartBeforeAdd =
          await fetchCart();
      } catch (error) {}

      await postJSON(
        shopRoute(
          'cart/add.js'
        ),
        {
          items: [item],
        }
      );

      let cartAfterAdd = null;

      try {
        cartAfterAdd =
          await fetchCart();
      } catch (error) {}

      const bogoAttributes =
        getBogoAttributes(
          root,
          card
        );

      if (bogoAttributes) {
        const cartAfterAttributes =
          await postJSON(
            shopRoute(
              'cart/update.js'
            ),
            {
              attributes:
                bogoAttributes,
            }
          );

        const latestCart =
          cartAfterAttributes ||
          cartAfterAdd;

        const knownCount =
          typeof latestCart
            ?.item_count ===
            'number'
            ? latestCart
                .item_count
            : null;

        const baselineCount =
          typeof cartBeforeAdd
            ?.item_count ===
            'number'
            ? cartBeforeAdd
                .item_count
            : null;

        const giftAlreadyPresent =
          knownCount !== null &&
          baselineCount !== null &&
          knownCount >
            baselineCount +
              quantity;

        if (
          !giftAlreadyPresent &&
          knownCount !== null
        ) {
          await waitForBogoGift(
            knownCount
          );
        }
      }

      window.location.href =
        getCheckoutUrl(
          root,
          card
        );
    } catch (error) {
      setStatus(
        card,
        error?.message ||
          'Unable to start checkout. Please try again.'
      );

      card.__btkV2OfferSubmitting =
        false;

      setButtonState(
        card,
        false
      );

      const handle =
        parseConfig(
          root
        ).flavorProductHandle;

      if (handle) {
        productRequests.delete(
          handle
        );
      }

      try {
        await syncFlavorAvailability(
          root,
          card
        );
      } catch (
        availabilityError
      ) {}
    }
  }

  function initCard(
    root,
    card
  ) {
    if (
      card.dataset
        .btkV2FlavorCheckoutInitialized ===
      'true'
    ) {
      return Promise.resolve();
    }

    card.dataset
      .btkV2FlavorCheckoutInitialized =
      'true';

    const button =
      getButton(card);

    if (!button) {
      return Promise.resolve();
    }

    const select =
      createFlavorSelector(
        root,
        card
      );

    createStatus(card);

    setButtonState(
      card,
      false
    );

    button.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        if (
          button.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          if (!select?.value) {
            setStatus(
              card,
              'Please choose an available protein flavor.'
            );
          }

          return;
        }

        handleCheckout(
          button
        );
      }
    );

    return syncFlavorAvailability(
      root,
      card
    );
  }

  function initRoot(root) {
    if (
      !root ||
      root.dataset
        .btkV2FlavorCheckoutRootInitialized ===
        'true'
    ) {
      return;
    }

    root.dataset
      .btkV2FlavorCheckoutRootInitialized =
      'true';

    const reloadState =
      getReloadState();

    const reloadMatchesRoot =
      !!reloadState &&
      (
        !reloadState.rootId ||
        reloadState.rootId ===
          root.id
      );

    const cards =
      Array.from(
        root.querySelectorAll(
          CARD_SELECTOR
        )
      );

    const tasks =
      cards.map(
        (card) =>
          initCard(
            root,
            card
          )
      );

    let resumeCard = null;

    if (reloadMatchesRoot) {
      resumeCard =
        cards.find(
          (card) =>
            getOfferKey(card) ===
            reloadState.offerKey
        ) || null;

      if (resumeCard) {
        const select =
          resumeCard.querySelector(
            FLAVOR_SELECTOR
          );

        if (
          select &&
          reloadState.variantId
        ) {
          select.value =
            String(
              reloadState
                .variantId
            );
        }

      }

      stripReloadMarker();
    }

    Promise.allSettled(
      tasks
    ).then(() => {
      cards.forEach(
        (card) =>
          setButtonState(
            card,
            false
          )
      );

      if (
        !reloadMatchesRoot ||
        reloadState?.mode !==
          'checkout' ||
        !resumeCard
      ) {
        return;
      }

      const button =
        getButton(
          resumeCard
        );

      const select =
        resumeCard.querySelector(
          FLAVOR_SELECTOR
        );

      const selectedOption =
        select &&
        select.selectedIndex >= 0
          ? select.options[
              select.selectedIndex
            ]
          : null;

      if (
        !button ||
        !select?.value ||
        !selectedOption ||
        selectedOption.disabled
      ) {
        setStatus(
          resumeCard,
          'That flavor is no longer available. Please choose another flavor.'
        );

        return;
      }

      restoreScroll(
        reloadState
      );

      setButtonState(
        resumeCard,
        true
      );

      window.setTimeout(
        () => {
          handleCheckout(
            button,
            {
              skipBogoReload:
                true,
            }
          );
        },
        30
      );
    });
  }

  function initAll(
    scope = document
  ) {
    if (
      scope.matches?.(
        ROOT_SELECTOR
      )
    ) {
      initRoot(scope);
      return;
    }

    scope
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(
        initRoot
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll()
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      initAll(
        event.target
      )
  );
})();